import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { TExternalTrackingLinkSource } from '../../../types/tracking'
import { ExternalTrackingLinkInfo } from './external-tracking-info'
import { TrackingLinkInfo } from './tracking-link-info'

interface ExternalTrackingLinkSourceProps {
  shipmentID: string
  trackingSourceData: TExternalTrackingLinkSource
}

/**
 * ExternalTrackingLinkSource displays the external tracking link for the shipment.
 */
export const ExternalTrackingLinkSource = (props: ExternalTrackingLinkSourceProps) => {
  const { trackingSourceData, shipmentID } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full" asChild={true}>
        <div className="w-full">
          <TrackingLinkInfo trackingSourceData={trackingSourceData} shipmentID={shipmentID} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <ExternalTrackingLinkInfo trackingSourceData={trackingSourceData} />
      </HoverCardContent>
    </HoverCard>
  )
}
